import Light from './Light'

export const HousenetLight = Light
export const HousenetDark = Light
